export const MOBILE_LAYOUT_MAX_WIDTH = 1024;
export const MOBILE_LAYOUT_MEDIA_QUERY = `(max-width: ${MOBILE_LAYOUT_MAX_WIDTH}px)`;
